import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
// TODO: import stencil components (se-icon)

function getComparatorActionsBlock({ comparatorStore, labelsStore, optionsStore }) {
  if (optionsStore.hideComparatorCta) {
    return null;
  }

  const compareInfo = `(${comparatorStore.comparatorArr.length}/${comparatorStore.comparatorMaxItems})`;

  return (
    <div className="actions-block__row">
      <PesIcon class="actions-block__icon icon--direction-x" size={pesIconSizes.SMALL}>
        action_compare
      </PesIcon>
      <a href={comparatorStore.comparatorUrlLink} className="pes-link actions-block__cta">{labelsStore.cardCompare}</a>
      <span className="actions-block__text--secondary">{compareInfo}</span>
    </div>
  );
}

const _Operations = (props) => {
  const { labelsStore, cartStore } = props;

  return (
    <>
      {getComparatorActionsBlock(props)}
      <div className="actions-block__row">
        <PesIcon class="actions-block__icon" size={pesIconSizes.SMALL}>
          action_delete
        </PesIcon>
        <span className="pes-link actions-block__cta" data-autotests-id="cart-link-remove-all" onClick={cartStore.removeAll}>
          {labelsStore.removeAll}
        </span>
      </div>
    </>
  );
};

getComparatorActionsBlock.propTypes = {
  labelsStore: propTypes.shape({
    cardCompare: propTypes.string.isRequired,
    removeAll: propTypes.string.isRequired
  }).isRequired,
  optionsStore: propTypes.shape({
    hideComparatorCta: propTypes.bool.isRequired
  }).isRequired,
  comparatorStore: propTypes.shape({
    comparatorArr: propTypes.object.isRequired,
    comparatorMaxItems: propTypes.number.isRequired,
    comparatorUrl: propTypes.string.isRequired,
    newComparatorUrlLink: propTypes.string.isRequired
  }).isRequired,
  cartStore: propTypes.shape({
    removeAll: propTypes.func
  }).isRequired
};

_Operations.propTypes = getComparatorActionsBlock.propTypes;

export const Operations = inject((allStores) => ({
  labelsStore: allStores.labelsStore,
  optionsStore: allStores.optionsStore,
  comparatorStore: allStores.comparatorStore,
  cartStore: allStores.cartStore
}))(observer(_Operations));
